const GrapeIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Leaf */}
      <path
        d="M22 7c4.5.5 8 3.5 9 7-3.5.8-7.2-1-9-4.5C20.5 12 18 14 15.5 14c0-3.5 2.8-6.5 6.5-7z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M22 7c-1 3-1.2 5.5-.5 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Bunch */}
      <circle cx="16" cy="20" r="3.2" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="23" cy="20" r="3.2" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="19.5" cy="25.5" r="3.2" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="12.5" cy="25.5" r="3" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="26.5" cy="25.5" r="3" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="19.5" cy="31.5" r="3" stroke="currentColor" strokeWidth="1.75" />
    </svg>
  );
};

export default GrapeIcon;
